<template>
	<div>
		<modalproduct :action="action" :editValue="editValue" :filter="{limit:limit, page: page, params:params, sort: sortBy, dir: sortDir}" :dialog="dialog" @hideDialog="() => { dialog = false }" @saveProduct="saveProduct"></modalproduct>
		<modalconfirm supplier ref="modalconfirmProdukSupplier" @action="actionProduct"></modalconfirm>
		<div class="d-flex justify-space-between">
			<div class="text-h5">Data Produk</div>
		</div>
		<v-card class="mt-3 mb-3" outlined>
			<v-list color="grey lighten-3" dark class="pa-3">
				<v-list-item dense class="px-1">
					<v-btn dark depressed class="cyan darken-2" @click="add">
						<v-icon>mdi-plus-circle</v-icon>
						<div class="pl-2 text-capitalize">Tambah Produk</div>
					</v-btn>
					<v-spacer></v-spacer>
					<v-btn text depressed class="cyan darken-2 mr-2" @click="exportData">
						<v-icon>mdi-export</v-icon>
						<div class="pl-2 text-capitalize">Export</div>
					</v-btn>
					<v-btn text depressed class="cyan darken-2" @click="dropfilter = !dropfilter">
						<v-icon>mdi-filter</v-icon>
						<div class="pl-2 text-capitalize">Filter</div>
					</v-btn>
				</v-list-item>
			</v-list>
		</v-card>
		<v-slide-y-transition>
			<v-card outlined class="mb-3" v-if="dropfilter">
				<v-col cols="12" class="px-3">
					<v-row>
						<v-col cols="12" md="3" >
							<v-text-field outlined dense hide-details label="Nama Produk" v-model="name.value" color="cyan darken-2"></v-text-field>
						</v-col>
						<v-col cols="12" md="3" >
							<v-text-field outlined dense hide-details label="Kode Produk" v-model="code.value" color="cyan darken-2"></v-text-field>
						</v-col>
						<v-col cols="12" md="3" >
							<v-menu v-model="dateMenu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field outlined dense :value="convertDate(tanggalOrder)" label="Terakhir Diorder" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" color="cyan darken-2"></v-text-field>
								</template>
								<v-date-picker range color="cyan darken-2" v-model="tanggalOrder"></v-date-picker>
							</v-menu>
						</v-col>
						<v-col cols="12" md="3" class="text-right">
							<v-btn outlined color="grey darken-1" dark class="text-capitalize" @click="resetFilter()">Reset</v-btn>
							<v-btn depressed color="cyan darken-2" dark class="ml-2 text-capitalize" @click="cari()">Cari</v-btn>
						</v-col>
					</v-row>
				</v-col>
				<v-card-actions class="px-3" v-if="false">
					<v-spacer></v-spacer>
					<v-btn outlined color="grey darken-1" dark class="text-capitalize" @click="resetFilter()">Reset</v-btn>
					<v-btn depressed color="cyan darken-2" dark class="ml-2 text-capitalize" @click="cari()">Cari</v-btn>
				</v-card-actions>
			</v-card>
		</v-slide-y-transition>
		<v-card outlined>
			<v-data-table loading disable-pagination :headers="headers" :items="listProduct" hide-default-footer :options.sync="option" :server-items-length="ProductPagination.total_data">
				<template v-slot:item.supplier_product_name="{ item }">
					<div class="d-flex">
						<div class="my-auto">{{ item.supplier_product_name }}</div>
					</div>
				</template>
				<template v-slot:item.supplier_product_price="{ item }">
					<div >{{ item.supplier_product_price | toNumber }}</div>
				</template>
				<template v-slot:item.supplier_product_last_order_datetime="{ item }">
					<div >{{ item.supplier_product_last_order_datetime | tanggaljam }}</div>
				</template>
				<template v-slot:item.action="{ item }">
					<v-tooltip dense bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn @click="edit(item)" class="mr-1" fab dark x-small depressed color="teal" v-bind="attrs" v-on="on">
								<v-icon dark>mdi-pencil</v-icon>
							</v-btn>
						</template>
						<span>Edit</span>
					</v-tooltip>
					<v-tooltip dense bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn @click="hapus(item.supplier_product_id)" class="" fab dark x-small depressed color="pink" v-bind="attrs" v-on="on">
								<v-icon dark>mdi-delete</v-icon>
							</v-btn>
						</template>
						<span>Hapus</span>
					</v-tooltip>
				</template>
				<template v-slot:progress>
					<div>
					</div>
				</template>
				<template v-slot:loading>
					<div class="py-3" v-if="!ProductPagination">
						<loading-data-cyan></loading-data-cyan>
					</div>
					<div class="py-3" v-else>
						<not-found-cyan></not-found-cyan>
					</div>
				</template>
			</v-data-table>
		</v-card>
		<div class="pt-5">
			<v-row>
				<v-col cols="10" md="11" class="py-0 d-flex justify-end">
					<v-pagination v-if="ProductPagination.total_page > 1 && listProduct.length > 0" v-model="page" :length="ProductPagination.total_page" total-visible="7" circle class="d-flex justify-end no-button-focus" color="cyan darken-2" @input="changePage"></v-pagination>
				</v-col>
				<v-col cols="2" md="1" class="py-0 pl-0">
					<v-autocomplete :items="listLimit" v-model="limit" hide-details class="mt-0" label="Item" color="cyan darken-2" item-color="cyan darken-4" @input="changeLimit"></v-autocomplete>
				</v-col>
			</v-row>
		</div>
	</div>
</template>

<script>
import modalproduct from '@/views/MLsupplier/product/ModalProduct'
import { mapActions, mapState, mapMutations } from 'vuex'

export default {
	inject: ['theme'],
	components: {
		modalproduct
	},
	data() {
		return {
			sortBy: 'supplier_product_name',
			sortDir: 'ASC',
			page: 1,
			limit: 10,
			listLimit: [ 5, 10, 20, 50, 100 ],
			paramProp: '',
			paramDelid: '',
			paramDelName: '',
			dialog: false,
			dialogConfirm: false,
			dropfilter: false,
			dateMenu: false,
			tanggalOrder: [],
			headers: [
			{ text: 'Nama Produk', align: 'start', value: 'supplier_product_name'},
			{ text: 'Kode Produk', value: 'supplier_product_code'},
			{ text: 'Satuan Produk', value: 'supplier_product_unit'},
			{ text: 'Harga Produk (Rp)', align: 'end', value: 'supplier_product_price'},
			{ text: 'Terakhir Diorder', value: 'supplier_product_last_order_datetime'},
			{ text: 'Aksi', value: 'action'},
			],
			code: {
				value:'',
				comparison:'like',
				type:'string',
				field:'supplier_product_code'
			},
			name: {
				value:'',
				comparison:'like',
				type:'string',
				field:'supplier_product_name'
			},
			dateOrder: {
				value:'',
				comparison: 'bet',
				type: 'date',
				field: 'supplier_product_last_order_datetime'
			},
			params:[],
			editValue: {},
			product_id: '',
			action: '',
		}
	},
	props: {
	},
	computed: {
		...mapState('supplierProduct', ['listProduct', 'ProductPagination', 'response']),
	},
	methods: {
		...mapActions('supplierProduct', ['getDataProduct', 'getProductUnit', 'addProduct', 'updateProduct', 'deleteProduct', 'exportDataProduct']),
		...mapMutations('supplierProduct', ['clearDataProduct', 'saveResponse']),
		...mapMutations(['setOverlay']),

		exportData(){
			this.exportDataProduct(this.queryString({params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		cari() {
			this.params = []
			if(this.code.value) {
				this.params.push(this.code)
			}
			if (this.name.value) {
				this.params.push(this.name)
			}
			if (this.dateOrder.value) {
				if (this.dateOrder.value.length > 1) {
					this.dateOrder.value.sort()
					let date = this.dateOrder.value.join('::')
					this.dateOrder.value = date
				}
				this.params.push(this.dateOrder)
			}
			this.getDataProduct(this.queryString({limit:this.limit, page: 1, params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		resetFilter() {
			this.code.value = ''
			this.name.value = ''
			this.dateOrder.value = ''
			this.params = []
			this.limit = 10
			this.getDataProduct(this.queryString({limit:this.limit, page: 1, params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		add() {
			this.dialog = true;
			this.action = 'add';
			this.editValue = {};
		},
		edit(val){
			this.dialog = true;
			this.action = 'edit'
			this.editValue = {
				product_id: val.supplier_product_id,
				code: val.supplier_product_code,
				unit: val.supplier_product_unit,
				name: val.supplier_product_name,
				price : val.supplier_product_price,
			}
		},
		hapus(id){
			this.product_id = id
			let msg = "Yakin akan menghapus produk ini?"
			this.$refs.modalconfirmProdukSupplier.showConfirm()
			this.$refs.modalconfirmProdukSupplier.setMessage(msg)
		},
		async actionProduct() {
			await this.setOverlay(true)
			await this.$refs.modalconfirmProdukSupplier.hideConfirm()
			await this.deleteProduct(this.product_id).then(() => {
				this.getDataProduct({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir})
			})
			await this.setOverlay(false)
		},
		async saveProduct(params) {
			await this.setOverlay(true)
			if (this.action == 'add') {
				await this.addProduct(params).then(() => {
					if (this.response.code == 200) {
						this.getDataProduct({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir})
						this.saveResponse({})
					}
				})
			} else {
				await this.updateProduct(params).then(() => {
					if (this.response.code == 200) {
						this.getDataProduct({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir})
						this.saveResponse({})
					}
				})
			}
			await this.setOverlay(false)
		},
		editProduct(params) {
			this.addProduct(params)
			this.getDataProduct({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir})
		},
		changePage(page) {
			this.page = page
			this.getDataProduct({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir})
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getDataProduct({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir})
		},
	},
	created() {
		this.getDataProduct()
		this.getProductUnit()
		this.$store.dispatch('setPageTitle', `Produk`);
	},
	beforeDestroy() {
		this.clearDataProduct()
	},
	watch: {
		tanggalOrder(val) {
			this.dateOrder.value = val
		},
		option(val, old) {
			this.sortBy = val.sortBy[0]
			this.sortDir = val.sortDesc[0] ? 'DESC' : 'ASC'
			this.page = 1
			if (this.sortBy || (!this.sortBy && Object.keys(old).length > 0)) {
				this.getDataProduct(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir}))
			}
		}
	}
}
</script>